import { cockpitDataProvider, getEnvironmentConfig } from "@airborne/react-admin";
import * as config from "../config";
const envConfig = getEnvironmentConfig(config);
const dataProvider = cockpitDataProvider(envConfig.apiBaseUrl);

export const getStatusListByGroup = groupId => {
  return dataProvider
    .getList("requeststatusgroups", {
      pagination: { page: 1, perPage: 9999 },
      sort: { field: "CreatedDate", order: "DESC" },
      filter: { requestStatusGroupType__eq: groupId },
    })
    .then(response => {
      let data = response.data;
      return dataProvider
        .getList("requeststatusinfos", {
          pagination: { page: 1, perPage: 9999 },
          sort: { field: "CreatedDate", order: "DESC" },
          filter: { requestStatus__in: data.map(e => e.requestStatusType) },
        })
        .then((result: any) => {
          return result.data;
        });
    })
    .catch(() => {
      return null;
    });
};
